import React, { Component } from 'react'

export class ProjectItem extends Component {
   render() {
      return (
         <div className='project--item'>
            <img src={"./img/" + this.props.item.foto} />
            <div className="project--content">
               <div className="project--text">
                  <h1 className='project--title'>{this.props.item.title}</h1>
                  <h2 className='project--category'>{this.props.item.category}</h2>
               </div>
               <button className='project--button'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
                     <g clip-path="url(#clip0_2_230)">
                        <path d="M1.771 14.6859L7.71386 8.00017L1.771 1.31445" stroke="#292F36" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                     </g>
                     <defs>
                        <clipPath id="clip0_2_230">
                           <rect width="9" height="16" fill="white" />
                        </clipPath>
                     </defs>
                  </svg>
               </button>
            </div>
         </div >
      )
   }
}

export default ProjectItem
